












import mixin from './cardmixin.vue'
import Vue from 'vue'
import { ProductionCardServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const productionCardService = new ProductionCardServiceProxy()
export default Vue.extend({
  name: 'doughnut-pie',
  mixins: [mixin],
  data() {
    return {}
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    index: {
      // 序号
      type: Number,
      default: null
    }
  },
  // watch: {
  //   id: {
  //     handler() {
  //       this.getList();
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      productionCardService.getCardInfo().then((res) => {
        if (res) {
          const legendData = []
          res.forEach((item) => {
            legendData.push(item.name)
          })
          this.init(legendData, res)
        }
      })
    },
    init(legendData, seriesData) {
      // console.log(222, this.$refs.myChart);
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(
        this.$refs.myChart
        // document.getElementById(`myChart-${this.index}`)
      )
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          selectedMode: false,
          data: legendData
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'inside',
              formatter: '{c}\n{d}%'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '24',
                position: 'center',
                fontWeight: 'bold',
                formatter: '{c}\n{d}%'
              }
            },
            labelLine: {
              show: false
            },
            data: seriesData
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    }
  }
})
